import type { Dimensions } from "schema/agent";
import type { AgentFiles } from "@/features/agent";
import type { ProjectState } from "./types";
import { ChatState } from "./types";

export const INITIAL_FILES: AgentFiles = {
  assets: [],
  helpers: {},
  init: `// Return resources { fonts, images, audio, videos } - system loads them automatically
async function init({ data }) {
  return {
    fonts: [
      { family: 'Inter', weights: [800] }
    ]
  };
}`,
  render: `// Context: { canvas, ctx, data, drawText, drawVideo, drawImage, getFrequencyData, getTimeDomainData }
// Canvas is auto-cleared before each frame
function render(time, { canvas, ctx, drawText }) {
  const t = time / 1000;

  // drawText: x,y are 0-1 relative to canvas
  drawText(ctx, {
    text: 'HELLO',
    font: 'Inter',
    weight: 800,
    size: 100,
    color: '#ffffff',
    x: 0.5,
    y: 0.5 + Math.sin(t * 2) * 0.03
  });
}`,
};

export const DEFAULT_DIMENSIONS: Dimensions = {
  width: 1080,
  height: 1920,
};

export const DEFAULT_DURATION = 3;

export const INITIAL_STATE: ProjectState = {
  chatState: ChatState.IDLE,
  files: INITIAL_FILES,
  dimensions: DEFAULT_DIMENSIONS,
  duration: DEFAULT_DURATION,
  messages: [],
  data: {},
};
